import React from 'react';
import ReactDOM from 'react-dom';
import Router from './Router';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as serviceWorker from './serviceWorker';
import './_Content/css/skeleton.scss';

ReactDOM.render(<Router />, document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();

if (localStorage.getItem('CodUsuario') == null) {
	if (
		window.location.href.indexOf('/erro') === -1 &&
		window.location.href.toLowerCase().indexOf('/validar-login') === -1
	)
		window.location = '/erro';
} else {
	if (isNaN(localStorage.getItem('CodUsuario'))) {
		localStorage.setItem('CodUsuario', localStorage.getItem('CodUsuario'));
	}
}

window.addEventListener('activate', function(event) {
	var cacheWhitelist = ['v2'];

	event.waitUntil(
		caches.keys().then(function(keyList) {
			return Promise.all(keyList.map(function(key) {
				if (cacheWhitelist.indexOf(key) === -1) {
					return caches.delete(key);
				}
			}));
		})
	);
});
